module.exports = __webpack_public_path__ + "static/media/icon-customer-invoice.42986914.svg";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/icon-customer-invoice.svg
// module id = 2390
// module chunks = 0